// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syncing-progress {
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 70px);
  text-align: center;
}

.syncing-header {
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.syncing-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.syncing-animation {
  margin-bottom: 60px;
}

.sync-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  margin-bottom: 40px;
  position: relative;
}

.platform-logo {
  width: 120px;
  height: 120px;
  background: white;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;
}

.platform-logo img {
  max-width: 100%;
  max-height: 100%;
}

.sync-arrows {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-circle {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-top,
.arrow-bottom {
  position: absolute;
  color: #1f2937;
  animation: syncRotate 2s linear infinite;
}

.arrow-top {
  top: -10px;
  right: 10px;
  transform-origin: center;
}

.arrow-bottom {
  bottom: -10px;
  left: 10px;
  transform: rotate(180deg);
  transform-origin: center;
}

@keyframes syncRotate {
  0% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
}

/* Alternative circular animation */
/* .arrow-circle::before {
  content: "";
  position: absolute;
  width: 100px;
  height: 100px;
  border: 3px solid #e5e7eb;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
} */

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.progress-indicator {
  max-width: 300px;
  margin: 0 auto;
}

.progress-text {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 15px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  border-radius: 4px;
  transition: width 0.5s ease;
}

.syncing-actions {
  margin-top: 40px;
}

.go-home-button {
  padding: 12px 32px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 150px;
}

.go-home-button:hover:not(:disabled) {
  background: #2563eb;
}

.go-home-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #9ca3af;
}

/* Pulsing animation for logos during sync */
.platform-logo {
  animation: logoPulse 2s ease-in-out infinite;
}

@keyframes logoPulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.2);
  }
}

@media (max-width: 768px) {
  .syncing-progress {
    padding: 20px;
  }

  .syncing-header h1 {
    font-size: 28px;
  }

  .sync-container {
    flex-direction: column;
    gap: 40px;
  }

  .sync-arrows {
    order: -1;
  }

  .arrow-top,
  .arrow-bottom {
    display: none;
  }

  .arrow-circle::before {
    width: 80px;
    height: 80px;
  }

  .platform-logo {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 480px) {
  .syncing-header h1 {
    font-size: 24px;
  }

  .platform-logo {
    width: 80px;
    height: 80px;
  }

  .progress-indicator {
    max-width: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/SyncingProgress/SyncingProgress.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,mCAAmC;AACnC;;;;;;;;;GASG;;AAEH;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,4CAA4C;AAC9C;;AAEA;EACE;;IAEE,mBAAmB;IACnB,yCAAyC;EAC3C;EACA;IACE,sBAAsB;IACtB,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".syncing-progress {\n  padding: 40px;\n  max-width: 800px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 70px);\n  text-align: center;\n}\n\n.syncing-header {\n  margin-bottom: 60px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.syncing-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0;\n}\n\n.syncing-animation {\n  margin-bottom: 60px;\n}\n\n.sync-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 60px;\n  margin-bottom: 40px;\n  position: relative;\n}\n\n.platform-logo {\n  width: 120px;\n  height: 120px;\n  background: white;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 2;\n}\n\n.platform-logo img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.sync-arrows {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.arrow-circle {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.arrow-top,\n.arrow-bottom {\n  position: absolute;\n  color: #1f2937;\n  animation: syncRotate 2s linear infinite;\n}\n\n.arrow-top {\n  top: -10px;\n  right: 10px;\n  transform-origin: center;\n}\n\n.arrow-bottom {\n  bottom: -10px;\n  left: 10px;\n  transform: rotate(180deg);\n  transform-origin: center;\n}\n\n@keyframes syncRotate {\n  0% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n}\n\n/* Alternative circular animation */\n/* .arrow-circle::before {\n  content: \"\";\n  position: absolute;\n  width: 100px;\n  height: 100px;\n  border: 3px solid #e5e7eb;\n  border-top: 3px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1.5s linear infinite;\n} */\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.progress-indicator {\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.progress-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 15px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #1d4ed8);\n  border-radius: 4px;\n  transition: width 0.5s ease;\n}\n\n.syncing-actions {\n  margin-top: 40px;\n}\n\n.go-home-button {\n  padding: 12px 32px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 150px;\n}\n\n.go-home-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.go-home-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #9ca3af;\n}\n\n/* Pulsing animation for logos during sync */\n.platform-logo {\n  animation: logoPulse 2s ease-in-out infinite;\n}\n\n@keyframes logoPulse {\n  0%,\n  100% {\n    transform: scale(1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.2);\n  }\n}\n\n@media (max-width: 768px) {\n  .syncing-progress {\n    padding: 20px;\n  }\n\n  .syncing-header h1 {\n    font-size: 28px;\n  }\n\n  .sync-container {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .sync-arrows {\n    order: -1;\n  }\n\n  .arrow-top,\n  .arrow-bottom {\n    display: none;\n  }\n\n  .arrow-circle::before {\n    width: 80px;\n    height: 80px;\n  }\n\n  .platform-logo {\n    width: 100px;\n    height: 100px;\n  }\n}\n\n@media (max-width: 480px) {\n  .syncing-header h1 {\n    font-size: 24px;\n  }\n\n  .platform-logo {\n    width: 80px;\n    height: 80px;\n  }\n\n  .progress-indicator {\n    max-width: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
